module.exports = __webpack_public_path__ + "img/401.acb5c19d.png";